<template>
	<div v-if="showTutorial && content" id="worksends-right-sidebar">
		<div id="worksends-help" v-html="content">
		</div>
	</div>
</template>

<script>
export default {
	name: 'HelpSidebar',
	props: ['helpContent'],
	data() {
		return {
			content: this.helpContent.text
		}
	},
	mounted() {

    },
	computed: {
		showTutorial() { return this.$store.state.currentUser.show_tutorial }
	}
}
</script>